// removed by extract-text-webpack-plugin
module.exports = {"Card":"_3_8mQaiH4GJ_Znixup9oE9","Body":"_1NE7HeUQQxmYbmh78kXCyw","Footer":"_3DcWZbbjj9cNmVI9aPjgw2","Group":"_2jEWI-4JVjO4ROpEkYv_Ad","Label":"_2P_PlJYiXrS1zqJeINEqhM","Select":"_2V5Y0U7knuE4rYe5Cxf1Yz","Input":"_3tBytBlag5VOb54ChRKx6U","Row":"_2A5UlNWcPG-QBvs9gTwuXZ","Btn":"_1zl-447gc5S2MvChZ33oV8","BtnReset":"_3wWg93WgrSesTZUTQy3gyL"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/AntiFraudFilters/antiFraudFilters.module.css
// module id = 525
// module chunks = 0